import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Text,
} from '@ltvco/refresh-lib/theme';

interface SeatRestrictedModalProps {
  onGoToDashboard: () => void;
}

export function SeatRestrictedModal({
  onGoToDashboard,
}: SeatRestrictedModalProps) {
  return (
    <Dialog
      open
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: '8px' } }}
    >
      <DialogContent sx={{ textAlign: 'center', pt: 4, pb: 1 }}>
        <DialogTitle sx={{ p: 0, mb: 1, fontSize: '20px', fontWeight: 700 }}>
          Admin access required
        </DialogTitle>
        <Text variant="body2" color="text.secondary">
          Contact your plan administrator to make changes to your plan.
        </Text>
      </DialogContent>
      <DialogActions
        sx={{ padding: '16px 24px 24px', justifyContent: 'center' }}
      >
        <Button variant="contained" onClick={onGoToDashboard}>
          Go to dashboard
        </Button>
      </DialogActions>
    </Dialog>
  );
}
